module.exports = __webpack_public_path__ + "static/media/enter_pin.30eecb58.png";